import Vue from 'vue'
import Vuex from 'vuex'

import dataEdit from './modules/data-edit/data-edit'
import dataManage from './modules/data-manage/data-manage'
import topicManage from './modules/topic-manage/topic-manage'
import roleManage from './modules/role-manage/role-manage'
import account from './modules/account/account'

import state from './state'
import mutations from './mutations'
import actions from './actions'

Vue.use(Vuex)
const store = new Vuex.Store({
  modules: {
    dataEdit: dataEdit,
    dataManage: dataManage,
    topicManage: topicManage,
    roleManage: roleManage,
    account: account
  },
  state,
  mutations,
  actions
})
export default store



// WEBPACK FOOTER //
// ./src/vuex/store.js